import { DRAWING_MODE, DRAWING_TOOL, POINT_MODE } from 'components/Map/constants';
import type { Position } from 'components/Map/types';

export { DRAWING_TOOL, DRAWING_MODE, POINT_MODE } from 'components/Map/constants';

export const DEFAULT_CENTER: Position = [-98.5795, 39.8283];

export const DEFAULT_DRAWING_TOOL = DRAWING_TOOL.POLYGON;

export const DEFAULT_DRAWING_MODE = DRAWING_MODE.APPLY;

export const DEFAULT_POINT_MODE = POINT_MODE.TOUCH;

export const DEFAULT_MAP_CENTER = DEFAULT_CENTER;
